import SignUp from './SignUp.jsx';

export default SignUp;
